var _rect, _rect2, _path, _path2, _g, _rect3, _g2, _rect4, _g3, _rect5, _g4, _rect6, _g5, _rect7, _g6, _rect8, _g7, _rect9, _g8, _rect10, _g9, _rect11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircuitSample = function SvgCircuitSample(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 692,
    height: 360,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 692,
    height: 360,
    fill: "#06061F",
    rx: 12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 692,
    height: 360,
    fill: "#fff",
    fillOpacity: 0.05,
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A9B0BC",
    d: "M32.418 49.316c0 1.606.891 2.816 2.464 2.816.902 0 1.617-.385 1.991-1.155v3.344h.759v-7.645h-.66l-.077 1.078c-.385-.825-1.122-1.221-2.013-1.221-1.54 0-2.464 1.177-2.464 2.783m.77.022c0-1.232.671-2.112 1.826-2.112 1.166 0 1.848.88 1.848 2.112 0 1.221-.682 2.112-1.848 2.112-1.155 0-1.826-.891-1.826-2.112m5.896 3.52h4.378v-.649h-4.378zm5.638-4.796c0 2.453 1.177 4.081 3.157 4.081 1.97 0 3.146-1.628 3.146-4.081 0-2.442-1.199-4.092-3.146-4.092-1.958 0-3.157 1.65-3.157 4.092m.781 0c0-2.057.87-3.366 2.376-3.366 1.507 0 2.376 1.309 2.376 3.366 0 2.046-.869 3.366-2.376 3.366s-2.376-1.32-2.376-3.366M32.418 112.816c0 1.606.891 2.816 2.464 2.816.902 0 1.617-.385 1.991-1.155v3.344h.759v-7.645h-.66l-.077 1.078c-.385-.825-1.122-1.221-2.013-1.221-1.54 0-2.464 1.177-2.464 2.783m.77.022c0-1.232.671-2.112 1.826-2.112 1.166 0 1.848.88 1.848 2.112 0 1.221-.682 2.112-1.848 2.112-1.155 0-1.826-.891-1.826-2.112m5.896 3.52h4.378v-.649h-4.378zm7.024-8.019v7.161h.76v-7.876h-2.366v.715zM32.418 176.316c0 1.606.891 2.816 2.464 2.816.902 0 1.617-.385 1.991-1.155v3.344h.759v-7.645h-.66l-.077 1.078c-.385-.825-1.122-1.221-2.013-1.221-1.54 0-2.464 1.177-2.464 2.783m.77.022c0-1.232.671-2.112 1.826-2.112 1.166 0 1.848.88 1.848 2.112 0 1.221-.682 2.112-1.848 2.112-1.155 0-1.826-.891-1.826-2.112m5.896 3.52h4.378v-.649h-4.378zm10.72-.858v-.737h-3.97l1.836-1.606c1.573-1.375 2.09-2.134 2.09-3.278 0-1.441-.99-2.398-2.475-2.398-1.55 0-2.596 1.089-2.64 2.739h.792c.033-1.221.748-2.013 1.837-2.013 1.045 0 1.683.649 1.683 1.716 0 .935-.374 1.485-1.826 2.75l-2.519 2.2V179zM32.418 239.816c0 1.606.891 2.816 2.464 2.816.902 0 1.617-.385 1.991-1.155v3.344h.759v-7.645h-.66l-.077 1.078c-.385-.825-1.122-1.221-2.013-1.221-1.54 0-2.464 1.177-2.464 2.783m.77.022c0-1.232.671-2.112 1.826-2.112 1.166 0 1.848.88 1.848 2.112 0 1.221-.682 2.112-1.848 2.112-1.155 0-1.826-.891-1.826-2.112m5.896 3.52h4.378v-.649h-4.378zm7.816-5.082c1.408 0 2.178.671 2.178 1.749 0 1.144-.759 1.892-1.936 1.892-1.11 0-1.815-.682-1.815-1.815h-.78c0 1.573 1.044 2.53 2.595 2.53 1.595 0 2.74-1.023 2.74-2.585 0-1.43-1.057-2.365-2.53-2.442l2.353-2.343v-.638h-4.774v.704h3.773l-2.43 2.398v.55zM32.418 303.316c0 1.606.891 2.816 2.464 2.816.902 0 1.617-.385 1.991-1.155v3.344h.759v-7.645h-.66l-.077 1.078c-.385-.825-1.122-1.221-2.013-1.221-1.54 0-2.464 1.177-2.464 2.783m.77.022c0-1.232.671-2.112 1.826-2.112 1.166 0 1.848.88 1.848 2.112 0 1.221-.682 2.112-1.848 2.112-1.155 0-1.826-.891-1.826-2.112m5.896 3.52h4.378v-.649h-4.378zm11.303-2.53v-.704h-.924v-5.5h-1.056l-3.85 5.5v.704h4.136V306h.77v-1.672zm-4.972-.704 3.278-4.686v4.686z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeOpacity: 0.15,
    d: "M68 52h600M68 116h600M68 180h600M68 244h600M68 308h600"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#circuitSample_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 120,
    x: 156,
    y: 24,
    fill: "#06061F",
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 120,
    x: 156,
    y: 24,
    fill: "#fff",
    fillOpacity: 0.09,
    rx: 12
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#circuitSample_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94.027,
    height: 92.611,
    x: 224.973,
    y: 93.834,
    fill: "#605EF5",
    rx: 46.305
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#circuitSample_svg__c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94.027,
    height: 92.611,
    x: 224.973,
    y: 93.834,
    fill: "#605EF5",
    rx: 46.305
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#circuitSample_svg__d)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 61,
    x: 141,
    y: 15,
    fill: "#9C5BBF",
    rx: 30.5
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m174.88 92 1.18-3.38h5.46L182.7 92h2.7l-5.28-14.62h-2.62L172.22 92zm3.6-10.26c.14-.4.26-.84.32-1.12.04.3.18.74.3 1.12l1.68 4.72h-3.96zm8.733 2.5v2.04h3.98v4h2.04v-4h3.98v-2.04h-3.98v-3.98h-2.04v3.98zM200.436 92h5.92c3.02 0 4.76-1.46 4.76-3.96 0-1.7-.78-2.86-2.32-3.36 1.38-.58 2.1-1.74 2.1-3.36 0-2.44-1.76-3.94-4.64-3.94h-5.82zm5.6-12.36c1.44 0 2.24.68 2.24 1.94 0 1.3-.78 2.04-2.18 2.04h-3.1v-3.98zm.22 6.14c1.42 0 2.24.7 2.24 1.94 0 1.32-.8 2.02-2.24 2.02h-3.26v-3.96z"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 119,
    x: 156.5,
    y: 24.5,
    stroke: "url(#circuitSample_svg__e)",
    rx: 11.5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#circuitSample_svg__f)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 184,
    x: 244,
    y: 24,
    fill: "#06061F",
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 184,
    x: 244,
    y: 24,
    fill: "#fff",
    fillOpacity: 0.09,
    rx: 12
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#circuitSample_svg__g)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94.027,
    height: 92.611,
    x: 312.973,
    y: 93.834,
    fill: "#605EF5",
    rx: 46.305
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#circuitSample_svg__h)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94.027,
    height: 92.611,
    x: 312.973,
    y: 93.834,
    fill: "#605EF5",
    rx: 46.305
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#circuitSample_svg__i)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 61,
    x: 229,
    y: 15,
    fill: "#9C5BBF",
    rx: 30.5
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m262.88 124 1.18-3.38h5.46l1.18 3.38h2.7l-5.28-14.62h-2.62L260.22 124zm3.6-10.26c.14-.4.26-.84.32-1.12.04.3.18.74.3 1.12l1.68 4.72h-3.96zm8.733 2.5v2.04h3.98v4h2.04v-4h3.98v-2.04h-3.98v-3.98h-2.04v3.98zm13.223 7.76h5.92c3.02 0 4.76-1.46 4.76-3.96 0-1.7-.78-2.86-2.32-3.36 1.38-.58 2.1-1.74 2.1-3.36 0-2.44-1.76-3.94-4.64-3.94h-5.82zm5.6-12.36c1.44 0 2.24.68 2.24 1.94 0 1.3-.78 2.04-2.18 2.04h-3.1v-3.98zm.22 6.14c1.42 0 2.24.7 2.24 1.94 0 1.32-.8 2.02-2.24 2.02h-3.26v-3.96zm7.188-1.54v2.04h3.98v4h2.04v-4h3.98v-2.04h-3.98v-3.98h-2.04v3.98zm19.403 8c3.46 0 6.14-2.04 6.7-5.12h-2.66c-.48 1.62-2 2.66-3.98 2.66-2.68 0-4.4-2-4.4-5.1 0-3.12 1.7-5.08 4.4-5.08 1.94 0 3.4 1 3.9 2.7h2.7c-.5-3.14-3.08-5.16-6.54-5.16-4.28 0-7.14 3.02-7.14 7.56 0 4.58 2.76 7.54 7.02 7.54"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 183,
    x: 244.5,
    y: 24.5,
    stroke: "url(#circuitSample_svg__j)",
    rx: 11.5
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#circuitSample_svg__k)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 129,
    height: 248,
    x: 361,
    y: 24,
    fill: "#06061F",
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 129,
    height: 248,
    x: 361,
    y: 24,
    fill: "#fff",
    fillOpacity: 0.09,
    rx: 12
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#circuitSample_svg__l)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94.027,
    height: 92.611,
    x: 429.973,
    y: 93.834,
    fill: "#605EF5",
    rx: 46.305
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#circuitSample_svg__m)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94.027,
    height: 92.611,
    x: 429.973,
    y: 93.834,
    fill: "#605EF5",
    rx: 46.305
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#circuitSample_svg__n)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 61,
    x: 346,
    y: 15,
    fill: "#9C5BBF",
    rx: 30.5
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m379.88 156 1.18-3.38h5.46l1.18 3.38h2.7l-5.28-14.62h-2.62L377.22 156zm3.6-10.26c.14-.4.26-.84.32-1.12.04.3.18.74.3 1.12l1.68 4.72h-3.96zm8.733 2.5v2.04h3.98v4h2.04v-4h3.98v-2.04h-3.98v-3.98h-2.04v3.98zm13.223 7.76h5.92c3.02 0 4.76-1.46 4.76-3.96 0-1.7-.78-2.86-2.32-3.36 1.38-.58 2.1-1.74 2.1-3.36 0-2.44-1.76-3.94-4.64-3.94h-5.82zm5.6-12.36c1.44 0 2.24.68 2.24 1.94 0 1.3-.78 2.04-2.18 2.04h-3.1v-3.98zm.22 6.14c1.42 0 2.24.7 2.24 1.94 0 1.32-.8 2.02-2.24 2.02h-3.26v-3.96zm7.188-1.54v2.04h3.98v4h2.04v-4h3.98v-2.04h-3.98v-3.98h-2.04v3.98zm19.403 8c3.46 0 6.14-2.04 6.7-5.12h-2.66c-.48 1.62-2 2.66-3.98 2.66-2.68 0-4.4-2-4.4-5.1 0-3.12 1.7-5.08 4.4-5.08 1.94 0 3.4 1 3.9 2.7h2.7c-.5-3.14-3.08-5.16-6.54-5.16-4.28 0-7.14 3.02-7.14 7.56 0 4.58 2.76 7.54 7.02 7.54m8.976-8v2.04h3.98v4h2.04v-4h3.98v-2.04h-3.98v-3.98h-2.04v3.98zm18.483 7.76c4.24 0 7.16-2.98 7.16-7.28 0-4.36-2.98-7.34-7.3-7.34h-5.12V156zm-.38-12.26c3.02 0 4.84 1.88 4.84 4.98 0 3.04-1.78 4.92-4.7 4.92h-2.46v-9.9z"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 247,
    x: 361.5,
    y: 24.5,
    stroke: "url(#circuitSample_svg__o)",
    rx: 11.5
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#circuitSample_svg__p)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 154,
    height: 312,
    x: 506,
    y: 24,
    fill: "#06061F",
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 154,
    height: 312,
    x: 506,
    y: 24,
    fill: "#fff",
    fillOpacity: 0.09,
    rx: 12
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#circuitSample_svg__q)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94.027,
    height: 92.611,
    x: 574.973,
    y: 93.834,
    fill: "#605EF5",
    rx: 46.305
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#circuitSample_svg__r)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94.027,
    height: 92.611,
    x: 574.973,
    y: 93.834,
    fill: "#605EF5",
    rx: 46.305
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#circuitSample_svg__s)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 61,
    x: 491,
    y: 15,
    fill: "#9C5BBF",
    rx: 30.5
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m524.88 188 1.18-3.38h5.46l1.18 3.38h2.7l-5.28-14.62h-2.62L522.22 188zm3.6-10.26c.14-.4.26-.84.32-1.12.04.3.18.74.3 1.12l1.68 4.72h-3.96zm8.733 2.5v2.04h3.98v4h2.04v-4h3.98v-2.04h-3.98v-3.98h-2.04v3.98zm13.223 7.76h5.92c3.02 0 4.76-1.46 4.76-3.96 0-1.7-.78-2.86-2.32-3.36 1.38-.58 2.1-1.74 2.1-3.36 0-2.44-1.76-3.94-4.64-3.94h-5.82zm5.6-12.36c1.44 0 2.24.68 2.24 1.94 0 1.3-.78 2.04-2.18 2.04h-3.1v-3.98zm.22 6.14c1.42 0 2.24.7 2.24 1.94 0 1.32-.8 2.02-2.24 2.02h-3.26v-3.96zm7.188-1.54v2.04h3.98v4h2.04v-4h3.98v-2.04h-3.98v-3.98h-2.04v3.98zm19.403 8c3.46 0 6.14-2.04 6.7-5.12h-2.66c-.48 1.62-2 2.66-3.98 2.66-2.68 0-4.4-2-4.4-5.1 0-3.12 1.7-5.08 4.4-5.08 1.94 0 3.4 1 3.9 2.7h2.7c-.5-3.14-3.08-5.16-6.54-5.16-4.28 0-7.14 3.02-7.14 7.56 0 4.58 2.76 7.54 7.02 7.54m8.976-8v2.04h3.98v4h2.04v-4h3.98v-2.04h-3.98v-3.98h-2.04v3.98zm18.483 7.76c4.24 0 7.16-2.98 7.16-7.28 0-4.36-2.98-7.34-7.3-7.34h-5.12V188zm-.38-12.26c3.02 0 4.84 1.88 4.84 4.98 0 3.04-1.78 4.92-4.7 4.92h-2.46v-9.9zm9.904 4.5v2.04h3.98v4h2.04v-4h3.98v-2.04h-3.98v-3.98h-2.04v3.98zm22.304 7.76v-2.36h-6.52v-3.88h5.84v-2.26h-5.84v-3.76h6.52v-2.36h-9.08V188z"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 153,
    height: 311,
    x: 506.5,
    y: 24.5,
    stroke: "url(#circuitSample_svg__t)",
    rx: 11.5
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#circuitSample_svg__u)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 56,
    x: 76,
    y: 24,
    fill: "#06061F",
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 56,
    x: 76,
    y: 24,
    fill: "#fff",
    fillOpacity: 0.09,
    rx: 12
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#circuitSample_svg__v)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94.027,
    height: 92.611,
    x: 144.973,
    y: 93.834,
    fill: "#605EF5",
    rx: 46.305
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#circuitSample_svg__w)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94.027,
    height: 92.611,
    x: 144.973,
    y: 93.834,
    fill: "#605EF5",
    rx: 46.305
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#circuitSample_svg__x)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 61,
    x: 61,
    y: 15,
    fill: "#9C5BBF",
    rx: 30.5
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m104.073 60 1.18-3.38h5.46l1.18 3.38h2.7l-5.28-14.62h-2.62L101.413 60zm3.6-10.26c.14-.4.26-.84.32-1.12.04.3.18.74.3 1.12l1.68 4.72h-3.96z"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 55,
    x: 76.5,
    y: 24.5,
    stroke: "url(#circuitSample_svg__y)",
    rx: 11.5
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#circuitSample_svg__z)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 56,
    x: 76,
    y: 88,
    fill: "#06061F",
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 56,
    x: 76,
    y: 88,
    fill: "#fff",
    fillOpacity: 0.09,
    rx: 12
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#circuitSample_svg__A)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94.027,
    height: 92.611,
    x: 144.973,
    y: 157.833,
    fill: "#605EF5",
    rx: 46.305
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#circuitSample_svg__B)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94.027,
    height: 92.611,
    x: 144.973,
    y: 157.833,
    fill: "#605EF5",
    rx: 46.305
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#circuitSample_svg__C)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 61,
    x: 61,
    y: 79,
    fill: "#9C5BBF",
    rx: 30.5
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M103.106 124h5.92c3.02 0 4.76-1.46 4.76-3.96 0-1.7-.78-2.86-2.32-3.36 1.38-.58 2.1-1.74 2.1-3.36 0-2.44-1.76-3.94-4.64-3.94h-5.82zm5.6-12.36c1.44 0 2.24.68 2.24 1.94 0 1.3-.78 2.04-2.18 2.04h-3.1v-3.98zm.22 6.14c1.42 0 2.24.7 2.24 1.94 0 1.32-.8 2.02-2.24 2.02h-3.26v-3.96z"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 55,
    x: 76.5,
    y: 88.5,
    stroke: "url(#circuitSample_svg__D)",
    rx: 11.5
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#circuitSample_svg__E)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 56,
    x: 76,
    y: 152,
    fill: "#06061F",
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 56,
    x: 76,
    y: 152,
    fill: "#fff",
    fillOpacity: 0.09,
    rx: 12
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#circuitSample_svg__F)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94.027,
    height: 92.611,
    x: 144.973,
    y: 221.833,
    fill: "#605EF5",
    rx: 46.305
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#circuitSample_svg__G)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94.027,
    height: 92.611,
    x: 144.973,
    y: 221.833,
    fill: "#605EF5",
    rx: 46.305
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#circuitSample_svg__H)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 61,
    x: 61,
    y: 143,
    fill: "#9C5BBF",
    rx: 30.5
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M108.212 188.24c3.46 0 6.14-2.04 6.7-5.12h-2.66c-.48 1.62-2 2.66-3.98 2.66-2.68 0-4.4-2-4.4-5.1 0-3.12 1.7-5.08 4.4-5.08 1.94 0 3.4 1 3.9 2.7h2.7c-.5-3.14-3.08-5.16-6.54-5.16-4.28 0-7.14 3.02-7.14 7.56 0 4.58 2.76 7.54 7.02 7.54"
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 55,
    x: 76.5,
    y: 152.5,
    stroke: "url(#circuitSample_svg__I)",
    rx: 11.5
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#circuitSample_svg__J)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 56,
    x: 76,
    y: 216,
    fill: "#06061F",
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 56,
    x: 76,
    y: 216,
    fill: "#fff",
    fillOpacity: 0.09,
    rx: 12
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#circuitSample_svg__K)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94.027,
    height: 92.611,
    x: 144.973,
    y: 285.833,
    fill: "#605EF5",
    rx: 46.305
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#circuitSample_svg__L)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94.027,
    height: 92.611,
    x: 144.973,
    y: 285.833,
    fill: "#605EF5",
    rx: 46.305
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#circuitSample_svg__M)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 61,
    x: 61,
    y: 207,
    fill: "#9C5BBF",
    rx: 30.5
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M107.478 252c4.24 0 7.16-2.98 7.16-7.28 0-4.36-2.98-7.34-7.3-7.34h-5.12V252zm-.38-12.26c3.02 0 4.84 1.88 4.84 4.98 0 3.04-1.78 4.92-4.7 4.92h-2.46v-9.9z"
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 55,
    x: 76.5,
    y: 216.5,
    stroke: "url(#circuitSample_svg__N)",
    rx: 11.5
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#circuitSample_svg__O)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 56,
    x: 76,
    y: 280,
    fill: "#06061F",
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 56,
    x: 76,
    y: 280,
    fill: "#fff",
    fillOpacity: 0.09,
    rx: 12
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#circuitSample_svg__P)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94.027,
    height: 92.611,
    x: 144.973,
    y: 349.833,
    fill: "#605EF5",
    rx: 46.305
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#circuitSample_svg__Q)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94.027,
    height: 92.611,
    x: 144.973,
    y: 349.833,
    fill: "#605EF5",
    rx: 46.305
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#circuitSample_svg__R)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 61,
    x: 61,
    y: 271,
    fill: "#9C5BBF",
    rx: 30.5
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M112.772 316v-2.36h-6.52v-3.88h5.84v-2.26h-5.84v-3.76h6.52v-2.36h-9.08V316z"
  }))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 55,
    x: 76.5,
    y: 280.5,
    stroke: "url(#circuitSample_svg__S)",
    rx: 11.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "circuitSample_svg__b",
    width: 494.027,
    height: 492.61,
    x: 24.973,
    y: -106.167,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_752_4619",
    stdDeviation: 100
  })), /*#__PURE__*/React.createElement("filter", {
    id: "circuitSample_svg__c",
    width: 494.027,
    height: 492.61,
    x: 24.973,
    y: -106.167,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_752_4619",
    stdDeviation: 100
  })), /*#__PURE__*/React.createElement("filter", {
    id: "circuitSample_svg__d",
    width: 462,
    height: 461,
    x: -59,
    y: -185,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_752_4619",
    stdDeviation: 100
  })), /*#__PURE__*/React.createElement("filter", {
    id: "circuitSample_svg__g",
    width: 494.027,
    height: 492.61,
    x: 112.973,
    y: -106.167,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_752_4619",
    stdDeviation: 100
  })), /*#__PURE__*/React.createElement("filter", {
    id: "circuitSample_svg__h",
    width: 494.027,
    height: 492.61,
    x: 112.973,
    y: -106.167,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_752_4619",
    stdDeviation: 100
  })), /*#__PURE__*/React.createElement("filter", {
    id: "circuitSample_svg__i",
    width: 462,
    height: 461,
    x: 29,
    y: -185,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_752_4619",
    stdDeviation: 100
  })), /*#__PURE__*/React.createElement("filter", {
    id: "circuitSample_svg__l",
    width: 494.027,
    height: 492.61,
    x: 229.973,
    y: -106.167,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_752_4619",
    stdDeviation: 100
  })), /*#__PURE__*/React.createElement("filter", {
    id: "circuitSample_svg__m",
    width: 494.027,
    height: 492.61,
    x: 229.973,
    y: -106.167,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_752_4619",
    stdDeviation: 100
  })), /*#__PURE__*/React.createElement("filter", {
    id: "circuitSample_svg__n",
    width: 462,
    height: 461,
    x: 146,
    y: -185,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_752_4619",
    stdDeviation: 100
  })), /*#__PURE__*/React.createElement("filter", {
    id: "circuitSample_svg__q",
    width: 494.027,
    height: 492.61,
    x: 374.973,
    y: -106.167,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_752_4619",
    stdDeviation: 100
  })), /*#__PURE__*/React.createElement("filter", {
    id: "circuitSample_svg__r",
    width: 494.027,
    height: 492.61,
    x: 374.973,
    y: -106.167,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_752_4619",
    stdDeviation: 100
  })), /*#__PURE__*/React.createElement("filter", {
    id: "circuitSample_svg__s",
    width: 462,
    height: 461,
    x: 291,
    y: -185,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_752_4619",
    stdDeviation: 100
  })), /*#__PURE__*/React.createElement("filter", {
    id: "circuitSample_svg__v",
    width: 494.027,
    height: 492.61,
    x: -55.027,
    y: -106.167,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_752_4619",
    stdDeviation: 100
  })), /*#__PURE__*/React.createElement("filter", {
    id: "circuitSample_svg__w",
    width: 494.027,
    height: 492.61,
    x: -55.027,
    y: -106.167,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_752_4619",
    stdDeviation: 100
  })), /*#__PURE__*/React.createElement("filter", {
    id: "circuitSample_svg__x",
    width: 462,
    height: 461,
    x: -139,
    y: -185,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_752_4619",
    stdDeviation: 100
  })), /*#__PURE__*/React.createElement("filter", {
    id: "circuitSample_svg__A",
    width: 494.027,
    height: 492.61,
    x: -55.027,
    y: -42.166,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_752_4619",
    stdDeviation: 100
  })), /*#__PURE__*/React.createElement("filter", {
    id: "circuitSample_svg__B",
    width: 494.027,
    height: 492.61,
    x: -55.027,
    y: -42.166,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_752_4619",
    stdDeviation: 100
  })), /*#__PURE__*/React.createElement("filter", {
    id: "circuitSample_svg__C",
    width: 462,
    height: 461,
    x: -139,
    y: -121,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_752_4619",
    stdDeviation: 100
  })), /*#__PURE__*/React.createElement("filter", {
    id: "circuitSample_svg__F",
    width: 494.027,
    height: 492.61,
    x: -55.027,
    y: 21.834,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_752_4619",
    stdDeviation: 100
  })), /*#__PURE__*/React.createElement("filter", {
    id: "circuitSample_svg__G",
    width: 494.027,
    height: 492.61,
    x: -55.027,
    y: 21.834,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_752_4619",
    stdDeviation: 100
  })), /*#__PURE__*/React.createElement("filter", {
    id: "circuitSample_svg__H",
    width: 462,
    height: 461,
    x: -139,
    y: -57,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_752_4619",
    stdDeviation: 100
  })), /*#__PURE__*/React.createElement("filter", {
    id: "circuitSample_svg__K",
    width: 494.027,
    height: 492.61,
    x: -55.027,
    y: 85.834,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_752_4619",
    stdDeviation: 100
  })), /*#__PURE__*/React.createElement("filter", {
    id: "circuitSample_svg__L",
    width: 494.027,
    height: 492.61,
    x: -55.027,
    y: 85.834,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_752_4619",
    stdDeviation: 100
  })), /*#__PURE__*/React.createElement("filter", {
    id: "circuitSample_svg__M",
    width: 462,
    height: 461,
    x: -139,
    y: 7,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_752_4619",
    stdDeviation: 100
  })), /*#__PURE__*/React.createElement("filter", {
    id: "circuitSample_svg__P",
    width: 494.027,
    height: 492.61,
    x: -55.027,
    y: 149.833,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_752_4619",
    stdDeviation: 100
  })), /*#__PURE__*/React.createElement("filter", {
    id: "circuitSample_svg__Q",
    width: 494.027,
    height: 492.61,
    x: -55.027,
    y: 149.833,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_752_4619",
    stdDeviation: 100
  })), /*#__PURE__*/React.createElement("filter", {
    id: "circuitSample_svg__R",
    width: 462,
    height: 461,
    x: -139,
    y: 71,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_752_4619",
    stdDeviation: 100
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "circuitSample_svg__e",
    x1: 248.16,
    x2: 118.047,
    y1: -6,
    y2: 8.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0060FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC74F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "circuitSample_svg__j",
    x1: 373.28,
    x2: 190.389,
    y1: -22,
    y2: -3.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0060FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC74F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "circuitSample_svg__o",
    x1: 526.12,
    x2: 292.278,
    y1: -38,
    y2: -15.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0060FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC74F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "circuitSample_svg__t",
    x1: 703.12,
    x2: 423.699,
    y1: -54,
    y2: -28.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0060FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC74F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "circuitSample_svg__y",
    x1: 157.92,
    x2: 45.924,
    y1: 10,
    y2: 33.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0060FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC74F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "circuitSample_svg__D",
    x1: 157.92,
    x2: 45.924,
    y1: 74,
    y2: 97.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0060FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC74F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "circuitSample_svg__I",
    x1: 157.92,
    x2: 45.924,
    y1: 138,
    y2: 161.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0060FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC74F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "circuitSample_svg__N",
    x1: 157.92,
    x2: 45.924,
    y1: 202,
    y2: 225.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0060FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC74F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "circuitSample_svg__S",
    x1: 157.92,
    x2: 45.924,
    y1: 266,
    y2: 289.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0060FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC74F5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "circuitSample_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 120,
    x: 156,
    y: 24,
    fill: "#fff",
    rx: 12
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "circuitSample_svg__f"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 184,
    x: 244,
    y: 24,
    fill: "#fff",
    rx: 12
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "circuitSample_svg__k"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 129,
    height: 248,
    x: 361,
    y: 24,
    fill: "#fff",
    rx: 12
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "circuitSample_svg__p"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 154,
    height: 312,
    x: 506,
    y: 24,
    fill: "#fff",
    rx: 12
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "circuitSample_svg__u"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 56,
    x: 76,
    y: 24,
    fill: "#fff",
    rx: 12
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "circuitSample_svg__z"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 56,
    x: 76,
    y: 88,
    fill: "#fff",
    rx: 12
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "circuitSample_svg__E"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 56,
    x: 76,
    y: 152,
    fill: "#fff",
    rx: 12
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "circuitSample_svg__J"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 56,
    x: 76,
    y: 216,
    fill: "#fff",
    rx: 12
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "circuitSample_svg__O"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 56,
    x: 76,
    y: 280,
    fill: "#fff",
    rx: 12
  })))));
};
export default SvgCircuitSample;